import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { trackAccess as s, runTracked as t, trackExplicitDependencies as e, runUntracked as i } from "./tracking.js";
import { ObservationHandle as n } from "./tracking/ObservationHandle.js";

var l = /*#__PURE__*/function () {
  function l(s, t, e) {
    _classCallCheck(this, l);

    this.properties = s, this.propertyName = t, this.metadata = e, this._observers = null, this._accessed = null, this._handles = null, this.flags = 1 | (e.nonNullable ? 8 : 0) | (e.hasOwnProperty("value") ? 16 : 0) | (void 0 === e.get ? 32 : 0) | (void 0 === e.dependsOn ? 64 : 0);
  }

  _createClass(l, [{
    key: "destroy",
    value: function destroy() {
      this._accessed = null, this._observers = null, this._clearObservationHandles();
    }
  }, {
    key: "getComputed",
    value: function getComputed() {
      s(this);
      var n = this.properties.store,
          _l = this.propertyName,
          r = this.flags,
          h = n.get(_l);
      if (4 & r) return h;
      if (1 & ~r && n.has(_l)) return h;
      this.flags |= 4;
      var o = this.properties.host;
      var a;
      64 & r ? a = t(this, this.metadata.get, o) : (e(o, this), a = this.metadata.get.call(o)), n.set(_l, a, 1);
      var d = n.get(_l);
      return d === h ? this.flags &= -2 : i(this.commit, this), this.flags &= -5, d;
    }
  }, {
    key: "onObservableAccessed",
    value: function onObservableAccessed(s) {
      s !== this && (null === this._accessed && (this._accessed = []), this._accessed.includes(s) || this._accessed.push(s));
    }
  }, {
    key: "onTrackingEnd",
    value: function onTrackingEnd() {
      this._clearObservationHandles(), this.flags |= 32;
      var s = this._accessed;
      if (null === s) return;
      var t = this._handles;
      null === t && (t = this._handles = []);

      for (var _e = 0; _e < s.length; ++_e) {
        t.push(s[_e].observe(this));
      }

      s.length = 0;
    }
  }, {
    key: "observe",
    value: function observe(s) {
      return null === this._observers && (this._observers = []), this._observers.includes(s) || this._observers.push(s), new n(this._observers, s);
    }
  }, {
    key: "notifyChange",
    value: function notifyChange() {
      this.onInvalidated(), this.onCommitted();
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.onInvalidated();
    }
  }, {
    key: "onInvalidated",
    value: function onInvalidated() {
      2 & ~this.flags && (this.flags |= 1);
      var s = this._observers;
      if (null !== s) for (var _t = 0; _t < s.length; ++_t) {
        s[_t].onInvalidated();
      }
    }
  }, {
    key: "commit",
    value: function commit() {
      this.flags &= -2, this.onCommitted();
    }
  }, {
    key: "onCommitted",
    value: function onCommitted() {
      if (null === this._observers) return;

      var s = this._observers.slice();

      for (var _t2 = 0; _t2 < s.length; ++_t2) {
        s[_t2].onCommitted();
      }
    }
  }, {
    key: "_clearObservationHandles",
    value: function _clearObservationHandles() {
      var s = this._handles;

      if (null !== s) {
        for (var _t3 = 0; _t3 < s.length; ++_t3) {
          s[_t3].remove();
        }

        s.length = 0;
      }
    }
  }]);

  return l;
}();

export { l as Property };